import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore"; 
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; 
import { getAuth } from "firebase/auth"; 
import { FaTicketAlt } from "react-icons/fa";
import { Notyf } from "notyf"; // Importar Notyf
import "notyf/notyf.min.css"; // Importar estilos de Notyf

import { db, storage } from "../firebase";
import SidebarDash from "./SidebarDash";
import ImageWithRect from "./ImageWithReact";
import ImageInput from "./ImageInput";

const CreateRaffle = () => {
  const [title, setTitle] = useState("");
  const [startTicket, setStartTicket] = useState("0");
  const [endTicket, setEndTicket] = useState("99");
  const [drawDate, setDrawDate] = useState("");
  const [image, setImage] = useState(null);
  const [loadImage, setLoadImage] = useState(null);
  const [contactName, setContactName] = useState(""); // Nuevo estado para el nombre de contacto
  const [contactNumber, setContactNumber] = useState(""); // Nuevo estado para el número de contacto
  const [errorMessage, setErrorMessage] = useState(""); // State for error messages
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();
  const notyf = new Notyf(); 


  const validateTicketInput = (input) => {
    return /^\d+$/.test(input);
  };

  const generateUniqueFileName = (file) => {    
    const timestamp = Date.now();
    const randomNum = Math.floor(Math.random() * 10000);
    const extension = file.name.split('.').pop();
    return `raffleImage_${timestamp}_${randomNum}.${extension}`;
  };

  const handleTicketChange = (setter) => (e) => {
    const value = e.target.value;
    if (validateTicketInput(value) || value === "") {
      setter(value.padStart(2, '0'));
      setErrorMessage(""); 
    } else {
      setErrorMessage("El ticket debe contener solo números.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
     setLoading(true); 

    const start = parseInt(startTicket, 10);
    const end = parseInt(endTicket, 10);

    if (!title || !drawDate || start < 0 || end <= 0 || end < start || !image || !contactName || !contactNumber) {
      notyf.error("Por favor, completa todos los campos correctamente.");
      setLoading(false);
      return;
    }

    try {
      const user = auth.currentUser;
      if (!user) {
        notyf.error("No hay usuario en sesión.");
        setLoading(false);
        return;
      }

      const uniqueFileName = generateUniqueFileName(image);
      const imageRef = ref(storage, `raffleImages/${uniqueFileName}`);      
    
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      await addDoc(collection(db, "raffles"), {
        title,
        startTicket:String(startTicket) ,
        endTicket: String(endTicket),
        drawDate,
        imageUrl,
        userId: user.uid,
        contactName, // Agregar nombre de contacto
        contactNumber, // Agregar número de contacto
      });

      notyf.success("Rifa creada con éxito!");
      navigate("/raffles");
    } catch (error) {
      console.log("Error creando la rifa: ", error);
      notyf.error("Error al crear la rifa. Inténtalo de nuevo.");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-full" style={{ background: "#eaeaec" }}>
      <SidebarDash />
      <main className="p-7 w-full">
        <h1 className="text-2xl font-bold text-black flex items-center">
          <FaTicketAlt className="mr-2" /> Crear una nueva rifa
        </h1>
        <div className="py-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="w-full">
              <label className="block text-gray-700">Título</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                required
              />
            </div>
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-gray-700">Ticket desde</label>
                <input
                  type="number"
                  defaultValue={startTicket}
                  onChange={handleTicketChange(setStartTicket)}
                  className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                  required
                />
              </div>
              <div className="flex-1">
                <label className="block text-gray-700">Ticket hasta</label>
                <input
                  type="number"
                  defaultValue={endTicket}
                  onChange={handleTicketChange(setEndTicket)}
                  className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                  required
                />
              </div>
            </div>
            {errorMessage && <div className="text-red-600">{errorMessage}</div>}
            <div className="w-full">
              <label className="block text-gray-700">Fecha del sorteo</label>
              <input
                type="date"
                value={drawDate}
                onChange={(e) => setDrawDate(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                required
              />
            </div>
            <div className="w-full">
             <ImageInput setLoadImage={setLoadImage} setImage={setImage}/>
            </div>
            <div className="flex space-x-4">
            <div className="w-full">
              <label className="block text-gray-700">Organizador</label>
              <input
                type="text"
                value={contactName}
                onChange={(e) => setContactName(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                required
              />
            </div>
            <div className="w-full">
              <label className="block text-gray-700">Número de contacto</label>
              <input
                type="text"
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
                className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200"
                required
              />
            </div>
            
            </div>
            <button
              type="submit"
              className={`w-full bg-blue-500 text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading} // Deshabilitar el botón si está cargando
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg
                    className="animate-spin h-5 w-5 mr-3 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v2a6 6 0 100 12v2a8 8 0 01-8-8z"></path>
                  </svg>
                  Cargando...
                </div>
              ) : (
                "Crear Rifa"
              )}
            </button> 
          </form>
        </div>
      </main>
      <div className="p-7 w-full">
        <ImageWithRect 
          imageSrc={loadImage}
        showPreviously
        />
      </div>
    </div>
  );
};

export default CreateRaffle;
